import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useIsVerified, UserContext } from "../context/UserContext";
import VerifyUser from "../components/Auth/VerifyUser";
import { useAuth } from "../context/AuthContext";
import { useOpenField } from "../Store/MenuSlice";
export default function AuthRoutes() {
  const location = useLocation();
  const { isAuth } = useAuth();
  const { userInfo, isLoading } = useContext(UserContext);
  const verified = useIsVerified();

  return !isAuth ? (
    <Navigate state={{ from: location }} replace to="/login" />
  ) : !isLoading && !verified ? (
    <VerifyUser route={true} />
  ) : (
    <Outlet />
  );
}
